import { createFileRoute } from '@tanstack/react-router';
import { AuthorizationParams, AppState } from '@auth0/auth0-react';

import { buildOrgLoginOptions } from '../../components/shared/utilities/appUtilities';
import {
  getOrgSubdomainRedirectUri,
  redirectToOrgSubdomain,
} from '../../components/shared/authentication/orgSubdomain';
import { getAppConfig } from '../../data/app-config/configs/configUtilities';

export type LoginSearch = {
  appState?: AppState;
  authorizationParams?: AuthorizationParams;
};

export const Route = createFileRoute('/_public/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    appState: search.appState as AppState,
    authorizationParams: search.authorizationParams as AuthorizationParams,
  }),
  beforeLoad: async ({ search, context: { auth0 } }) => {
    /*
     * An organization served at its own subdomain is sent there before the login
     * starts: Auth0 lands every invitation for a shared application on that
     * application's one Application Login URI. Starting a login here as well would
     * race the navigation.
     */
    if (redirectToOrgSubdomain()) return;

    const { appState, authorizationParams } = search;

    const { loginWithRedirect } = auth0;
    const defaultReturnTo = getAppConfig().alternateBaseAppPath || '/';

    /*
     * Only set on an organization subdomain, where the provider default would
     * return the user to the shared host and undo the redirect above.
     */
    const orgRedirectUri = getOrgSubdomainRedirectUri();

    const opts = buildOrgLoginOptions({
      appState: {
        returnTo: defaultReturnTo,
        ...appState,
      },
      authorizationParams: {
        ...(orgRedirectUri ? { redirect_uri: orgRedirectUri } : {}),
        ...authorizationParams,
      },
    });

    loginWithRedirect(opts);
  },
});
